export default {
  breadcrumbAriaLabel: {
    id: 'buyback_breadcrumb_aria_label',
    defaultMessage: 'Breadcrumb product page trade in',
  },
  breadcrumbHome: {
    id: 'buyback_breadcrumb_home',
    defaultMessage: 'Trade-in home',
  },
}
